import * as Types from '../../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const NonF2fQuickDiagnosisDoctorDocument = `
    query NonF2fQuickDiagnosisDoctor($request: NonF2fQuickDiagnosisDoctorRequestInput!, $telemedicineTargetType: TelemedicineTargetType!, $contactType: DiagnosisContactType!) {
  nonF2fQuickDiagnosisDoctor(request: $request) {
    doctor {
      doctorId
      doctorPublicId
      diagnosisBookingSchedules(
        contactType: $contactType
        telemedicineTargetType: $telemedicineTargetType
      ) {
        targetDate
        schedules {
          startTimeSlot {
            value
          }
          endTimeSlot {
            value
          }
        }
      }
    }
  }
}
    `;
export const useNonF2fQuickDiagnosisDoctorQuery = <
      TData = Types.NonF2fQuickDiagnosisDoctorQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.NonF2fQuickDiagnosisDoctorQueryVariables,
      options?: UseQueryOptions<Types.NonF2fQuickDiagnosisDoctorQuery, TError, TData>,
    ) =>
    useQuery<Types.NonF2fQuickDiagnosisDoctorQuery, TError, TData>(
      ['NonF2fQuickDiagnosisDoctor', variables],
      gqlFetcher<Types.NonF2fQuickDiagnosisDoctorQuery, Types.NonF2fQuickDiagnosisDoctorQueryVariables>(NonF2fQuickDiagnosisDoctorDocument, 'NonF2fQuickDiagnosisDoctor', variables),
      options
    );

useNonF2fQuickDiagnosisDoctorQuery.getKey = (variables: Types.NonF2fQuickDiagnosisDoctorQueryVariables) => ['NonF2fQuickDiagnosisDoctor', variables];
;

useNonF2fQuickDiagnosisDoctorQuery.fetcher = (variables: Types.NonF2fQuickDiagnosisDoctorQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.NonF2fQuickDiagnosisDoctorQuery, Types.NonF2fQuickDiagnosisDoctorQueryVariables>(NonF2fQuickDiagnosisDoctorDocument, 'NonF2fQuickDiagnosisDoctor', variables, options);